export const DEFAULT_NAV_ITEMS = [
  { label: "Work", url: "/", isVisible: true },
  { label: "Portfolio", url: "/journalist-portfolio", isVisible: true },
  { label: "Fashion", url: "/fashion-journalist", isVisible: true },
  { label: "Music", url: "/music-journalist", isVisible: true },
  { label: "Culture", url: "/cultural-commentary", isVisible: true },
  { label: "Interviews", url: "/interviews", isVisible: true },
  { label: "About", url: "/about", isVisible: true },
];

export const normalizeNavigationItems = (items, fallback = DEFAULT_NAV_ITEMS) => {
  const source = Array.isArray(items) && items.length ? items : fallback;
  return source.map((item) => ({
    label: item?.label || "",
    url: item?.url || item?.to || "/",
    isVisible: item?.isVisible !== false && item?.visible !== false,
  }));
};

export const getVisibleNavigationItems = (items, fallback = DEFAULT_NAV_ITEMS) =>
  normalizeNavigationItems(items, fallback).filter((item) => item.isVisible);

export const getContactNavigation = (section) => ({
  label: section?.ctaLabel || "Contact",
  url: "/contact",
  isVisible: section?.content?.contactVisible !== false,
});
